import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Label } from '@pisaka/ui';
import { useResetPassword } from '../useAuth';

type ResetPasswordContainerType = {
  onCloseModal: () => void;
};

export const ResetPasswordContainer: FC<ResetPasswordContainerType> = ({ onCloseModal }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<string | undefined>();
  const [successMessage, setSuccessMessage] = useState<string | undefined>();
  const { isLoadingResetPassword, resetPasswordRequest, resetPasswordError, setResetPasswordError } = useResetPassword();

  const isValidEmail = email.includes('@') && email.includes('.');

  const onChangeEmail = (value: string) => {
    setEmail(value);
    if (emailError) setEmailError(undefined);
    if (resetPasswordError) setResetPasswordError(undefined);
    if (successMessage) setSuccessMessage(undefined);
  };

  const onRequestReset = async () => {
    try {
      await resetPasswordRequest(email);
      setSuccessMessage(t('auth.resetSuccessMessage'));
      setResetPasswordError(undefined);
    } catch (error) {
      if (error instanceof Error) setResetPasswordError(error.message);
      setSuccessMessage(undefined);
    }
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Label>{t('auth.resetEmailLabel')}</Label>
        <Input
          type="email"
          value={email}
          onChange={(e) => onChangeEmail(e.target.value)}
          placeholder={t('auth.emailPlaceholder')}
        />
        {emailError && <p className="text-sm text-destructive">{emailError}</p>}
      </div>
      {resetPasswordError && <p className="text-sm text-destructive">{resetPasswordError}</p>}
      {successMessage && <p className="text-sm text-green-600">{successMessage}</p>}
      <Button
        className="w-full bg-gradient-accent hover:bg-accent shadow-accent text-primary-foreground"
        onClick={onRequestReset}
        disabled={isLoadingResetPassword || !isValidEmail}
      >
        {isLoadingResetPassword ? '...' : t('auth.sendResetEmail')}
      </Button>
      {successMessage && (
        <Button className="w-full" variant="outline" onClick={onCloseModal}>
          {t('auth.close')}
        </Button>
      )}
    </div>
  );
};
